import { TooltipPlacement } from './Tooltip.styles'

type Pos = { top: number; left: number }

/**
 * Clamps a tooltip's position so it stays fully within the viewport.
 * - top/bottom placements: clamps the horizontal (left) axis.
 * - left/right placements: clamps the vertical (top) axis.
 *
 * The tooltip element must already be rendered (hidden) so its dimensions
 * can be measured before the clamped position is applied.
 */
export const clampTooltipPos = (
  pos: Pos,
  el: HTMLElement,
  placement: TooltipPlacement,
  padding: number
): Pos => {
  if (placement === 'top' || placement === 'bottom') {
    const half = el.offsetWidth / 2
    const left = Math.min(
      Math.max(pos.left, half + padding),
      window.innerWidth - half - padding
    )
    return { ...pos, left }
  }

  const half = el.offsetHeight / 2
  const top = Math.min(
    Math.max(pos.top, half + padding),
    window.innerHeight - half - padding
  )
  return { ...pos, top }
}
